import { gql, useQuery } from '@apollo/client'
import Modal from 'components/Modal'
import { useState } from 'react'
import { FaRedo, FaUndo } from 'react-icons/fa'
import { GetRapidPhotoQuery, GetRapidPhotoQueryVariables } from './__generated__/GetRapidPhotoQuery'

const getPhotoQuery = gql`
  query GetRapidPhotoQuery($id: ID!) {
    rapidPhotoById(id: $id) {
      id
      filename
      mimeType
      base64
    }
  }
`

interface ViewPhotoModalProps {
  photoKey: string
  onClose: () => void
}

const ConfirmPhotoModal = ({ photoKey, onClose }: ViewPhotoModalProps) => {
  const { loading, error, data } = useQuery<GetRapidPhotoQuery, GetRapidPhotoQueryVariables>(getPhotoQuery, {
    variables: { id: btoa(JSON.stringify(photoKey)) },
    fetchPolicy: 'cache-and-network',
  })

  const [imgSize, setImgSize] = useState({ width: 0, height: 0 })
  const [rotation, setRotation] = useState(0)
  const d = imgSize.width - imgSize.height

  if (error) {
    throw error
  }

  return (
    <Modal isShown={true} onRequestClose={() => onClose()}>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">
            <strong>Rapid Photo</strong>
          </p>
          <button onClick={() => onClose()} className="delete" aria-label="close"></button>
        </header>
        <section className="modal-card-body">
          {loading && <p>Loading...</p>}

          {data && (
            <>
              <div className="mb-1 is-fullwidth is-flex">
                <button
                  type="button"
                  className="button is-flex-grow-1 mr-1"
                  onClick={() => setRotation((prev) => prev - 1)}
                >
                  <FaUndo />
                </button>

                <button type="button" className="button is-flex-grow-1" onClick={() => setRotation((prev) => prev + 1)}>
                  <FaRedo />
                </button>
              </div>

              <img
                style={{
                  transform: `rotate(${rotation * 90}deg)`,
                  marginLeft: (-d / 2) * (rotation % 2),
                  marginTop: (d / 2) * (rotation % 2),
                }}
                onLoad={(e) => {
                  setImgSize({
                    width: e.target.offsetWidth,
                    height: e.target.offsetHeight,
                  })
                }}
                src={data.rapidPhotoById.base64}
                alt="Passport and test cassette"
              />
            </>
          )}
        </section>
      </div>
    </Modal>
  )
}

export default ConfirmPhotoModal
